import { memo } from "react";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import type { RejectedItem } from "../../../../lib/corpusApi";
import {
  DataSequence,
  type DataSequenceColumn,
} from "../../../../components/primitives/data-display/DataSequence";
import { DocumentLink } from "../../../../components/domain/data-display/DocumentLink";
import { LoadingState } from "../../../../components/primitives/feedback/LoadingState";
import { useRejectedDocuments } from "./useRejectedDocuments";
import { RejectionFindingSummary } from "../../../../components/domain/data-display/RejectionFindingSummary";

const columns: DataSequenceColumn<RejectedItem>[] = [
  {
    key: "url",
    header: "URL",
    width: 340,
    cardRole: "primary",
    cell: (item) => <DocumentLink title={item.url} url={item.url} />,
  },
  {
    key: "reason",
    header: "Reason",
    cell: (item) => <RejectionFindingSummary code={item.code} message={item.message} />,
  },
  {
    key: "rejectedAt",
    header: "Rejected",
    cell: (item) => (
      <Typography variant="caption" color="text.secondary">
        {new Date(item.rejectedAt).toLocaleDateString()}
      </Typography>
    ),
  },
];

/** Read-only list of URLs permanently rejected by the corpus admission gate. */
export const RejectedDocuments = memo(function RejectedDocuments() {
  const { items, loading, error, pagination } = useRejectedDocuments();

  if (error) return <Alert severity="error">{error}</Alert>;
  if (loading) return <LoadingState />;

  return (
    <DataSequence
      columns={columns}
      rows={items}
      getRowId={(item) => item.url}
      emptyMessage="No rejected documents."
      pagination={pagination}
    />
  );
});
